// Module
var code = "<template>\n\t<div class=\"container-fluid row\">\n\t\t<router-view></router-view>\n\t</div>\n</template>\n";
// Exports
export default code;